import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { BaseController } from '../../../core/abstractions/base.controller';
import { ShareInfoTypeEnum } from '../../../models/enums/share-info-type.enum';
import { ListTraderModel } from '../../../models/list-trader.model';
import { TraderSummaryModel } from '../../../models/trader-summary.model';
import { TraderModel } from '../../../models/trader.model';
import { TradersResource } from '../../../services/resources/traders.resource';

@Component({
    selector: 'sl-traders-view.component',
    templateUrl: './traders-view.component.html',
    styleUrls: ['./traders-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TradersViewComponent extends BaseController<TraderModel, TraderSummaryModel, ListTraderModel> {
    readonly ShareInfoTypeEnum = ShareInfoTypeEnum;

    protected override readonly _entityResource = inject(TradersResource);
}
